import { ERROR_EXCEPTION } from '@/constants';
import { Guide, NtaComment } from '@/__generated';
import { message } from 'antd';
import i18n from './i18n';
import { formatDisplayFullDate } from '@/config';

export const guidHasValue = (id: string | undefined | null) => id && id !== '00000000-0000-0000-0000-000000000000';

export const getGuideFullName = (guide: Guide | undefined | null) => {
  return `${guide?.lastNameKanji} ${guide?.firstNameKanji}`;
};

export const timeOnly2String = (value: string | null | undefined): string | null => {
  if (value && value.length > 5) {
    return value.slice(0, 5);
  }
  return null;
};

export const createNtaCommentsHtml = (comments: NtaComment[]) => {
  return (
    comments
      .map(c => {
        return `<div>
        <h4 style="margin-bottom:0">${formatDisplayFullDate(c.createdAt)} ${c.actor}</h4>
        <span>${c.comment?.replaceAll(`\n`, '<br/>')}</span>
    </div>`;
      })
      .join('<div style="border-top: 1px dashed #ccc;margin-top: 5px;margin-bottom: 5px;"> </div>') || ''
  );
};

export const hasAnyFieldValue = (data: any) => {
  if (!data) {
    return false;
  }
  const keys = Object.keys(data);
  return keys.some(key => data[key] !== undefined);
};

export const defaultApiErrorHandler = err => message.error(i18n.t(err.message || ERROR_EXCEPTION) as any);
